import { Flex, Form, Input, Button, Card, Breadcrumb } from 'antd'
import React, { useEffect, useState } from 'react'
import { KeyOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { useToasts } from 'react-toast-notifications';
import api from '../../service/axios'
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import { isMobile } from 'react-device-detect';


export const AlterarSenha = (props) => {

    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [user, setUser] = useRecoilState(userState)


    const onFinish = async (values) => {
        if (values.senha.trim() === values.senha2.trim()) {
            try {
                setLoading(true)
                const result = await api.post('/api/v1.0/registrado/alterar-senha', values, {
                    headers: {
                        'x-access-token': user?.token2
                    }
                })
                addToast("Senha alterada com sucesso!", { appearance: 'success', autoDismiss: true })
            } catch (error) {
                addToast(error.message, { appearance: 'error', autoDismiss: true })
            }
        }
        else
            addToast('As senhas não são iguais!', { appearance: 'error', autoDismiss: true })
        setLoading(false)
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };


    return <Flex vertical gap={15} >

        <Breadcrumb items={[
            {
                title: <Flex align='center' gap={5}>
                    <KeyOutlined />
                    Alterar Senha</Flex>,
            }
        ]} />
        <Flex justify='center' align='center' vertical flex={1}>
            <Card style={{ backgroundColor: 'white', width: isMobile ? 350 : 500 }}>

                <Flex justify='center'>
                    <b style={{ fontSize: '1.3em', marginBottom: 10 }}>Alteração de Senha</b>
                </Flex>

                <Form
                    layout='vertical'
                    name="basic"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Nova senha"
                        name="senha"
                        rules={[{ required: true, message: 'Informe a senha!', min: 4 }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        label="Confirme a senha"
                        name="senha2"
                        rules={[{ required: true, message: 'Confirme a senha!', min: 4 }]}
                    >
                        <Input.Password />
                    </Form.Item>



                    <Form.Item label={null}>
                        <Flex justify='center'>
                            <Button loading={loading} type="primary" htmlType="submit" style={{ marginTop: 15 }} block>
                                Salvar
                            </Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </Card>
        </Flex>
    </Flex>
}
